import { Box } from "@chakra-ui/react";
import { motion, useAnimation } from "framer-motion";
import { useState, useEffect, useRef, useCallback } from "react";
import lubDubSound from "../../../assets/sounds/lubdub.mp3";
import { BouncingBox } from "../../BouncingBox/BouncingBox";

const MotionBox = motion(Box);

export default function HeartIcon({ width = 17, height = 15, fill = "red" }) {
  const [boxes, setBoxes] = useState([]);
  const controls = useAnimation();
  const [isBeating, setIsBeating] = useState(false);

  // ref for Audio object
  const audioRef = useRef(null);
  // ref for the interval ID
  const intervalRef = useRef(null);

  // on mount, create the Audio
  useEffect(() => {
    const audio = new Audio(lubDubSound);
    audio.volume = 0.3; // 30% loudness
    audioRef.current = audio;
  }, []);

  const beat = useCallback(async () => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = 0;
      audio.play();
    }

    // visual "lub"
    await controls.start({ scale: 1.3, transition: { duration: 0.15 } });
    await controls.start({ scale: 1.0, transition: { duration: 0.15 } });
    // visual "dub"
    await controls.start({
      scale: 1.2,
      transition: { duration: 0.1, delay: 0.05 },
    });
    await controls.start({ scale: 1.0, transition: { duration: 0.1 } });
  }, [controls]);

  const toggleBeat = () => {
    setIsBeating((b) => !b);

    // if (bruhAudio.current) {
    // bruhAudio.current.currentTime = 0;
    // bruhAudio.current.play();
    // }

    // add a miss mango box
    const newBox = { id: Date.now() };
    setBoxes((prev) => [...prev, newBox]);
  };

  useEffect(() => {
    if (isBeating) {
      // play one immediately
      beat();
      // then schedule at 1 s intervals = 60 bpm
      intervalRef.current = window.setInterval(beat, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
    // cleanup on unmount or when isBeating changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isBeating, beat]);

  return (
    <>
      <MotionBox
        cursor="pointer"
        display="inline-block"
        animate={controls}
        onClick={toggleBeat}
        initial={{ scale: 1 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox="0 0 342 315"
        >
          <defs>
            <style>{`.outline { stroke: none; }`}</style>
            <g id="heart">
              <path d="M0 200 v-200 h200 a100,100 90 0,1 0,200 a100,100 90 0,1 -200,0 z" />
            </g>
          </defs>
          <use
            xlinkHref="#heart"
            className="outline"
            fill={fill}
            transform="rotate(225,150,121)"
          />
        </svg>
      </MotionBox>

      {boxes.map((box) => (
        <BouncingBox key={box.id} id={box.id} image="missMango" />
      ))}
    </>
  );
}
